import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCacheError = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 74,
	height: 70,
	viewBox: "0 0 74 70",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			stroke: "#FFF",
			strokeWidth: 2,
			children: /* @__PURE__ */ _jsxs("g", {
				transform: "translate(-1031.000000, -275.000000) translate(1032.000000, 276.000000)",
				children: [
					/* @__PURE__ */ _jsx("rect", {
						width: 56,
						height: 44,
						x: 8,
						y: 24,
						rx: 2
					}),
					/* @__PURE__ */ _jsx("path", { d: "M8 52V36c-4.418 0-8 3.582-8 8s3.582 8 8 8z" }),
					/* @__PURE__ */ _jsx("path", {
						d: "M41 29V9c-5.523 0-10 4.477-10 10s4.477 10 10 10z",
						transform: "translate(36.000000, 19.000000) rotate(-270.000000) translate(-36.000000, -19.000000)"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M72 52V36c-4.418 0-8 3.582-8 8s3.582 8 8 8z",
						transform: "translate(68.000000, 44.000000) scale(-1, 1) translate(-68.000000, -44.000000)"
					}),
					/* @__PURE__ */ _jsxs("g", {
						strokeLinecap: "round",
						children: [/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
							d: "M0 0L6 6",
							transform: "translate(22.000000, 44.000000)"
						}), /* @__PURE__ */ _jsx("path", {
							d: "M0 0L6 6",
							transform: "translate(22.000000, 44.000000) translate(3.000000, 3.000000) scale(-1, 1) translate(-3.000000, -3.000000)"
						})] }), /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
							d: "M0 0L6 6",
							transform: "translate(22.000000, 44.000000) translate(22.000000, 0.000000)"
						}), /* @__PURE__ */ _jsx("path", {
							d: "M0 0L6 6",
							transform: "translate(22.000000, 44.000000) translate(22.000000, 0.000000) translate(3.000000, 3.000000) scale(-1, 1) translate(-3.000000, -3.000000)"
						})] })]
					}),
					/* @__PURE__ */ _jsx("path", {
						strokeLinecap: "round",
						d: "M36 14L36 4.238"
					}),
					/* @__PURE__ */ _jsx("circle", {
						cx: 36,
						cy: 2,
						r: 2
					}),
					/* @__PURE__ */ _jsx("circle", {
						cx: 36,
						cy: 58,
						r: 4
					})
				]
			})
		})
	})
});
export default SvgCacheError;
